/** Export the visible card, including HTML metric charts, as a self-contained SVG image. */
export function exportChartImage(element: HTMLElement, title: string) {
  const copy = element.cloneNode(true) as HTMLElement;
  const originals = [element, ...element.querySelectorAll('*')];
  const clones = [copy, ...copy.querySelectorAll('*')];
  originals.forEach((original, index) => {
    const clone = clones[index] as HTMLElement | SVGElement;
    const styles = getComputedStyle(original);
    for (const property of Array.from(styles))
      clone.style.setProperty(
        property,
        styles.getPropertyValue(property).replace(/url\(["']?[^)"']*#([^)"']+)["']?\)/g, 'url(#$1)')
      );
    for (const attribute of [...clone.attributes])
      if (attribute.name.startsWith('on')) clone.removeAttribute(attribute.name);
  });
  copy.querySelectorAll('[data-export-ignore],script').forEach((node) => node.remove());
  const { width, height } = element.getBoundingClientRect();
  copy.style.width = `${width}px`;
  copy.style.height = `${height}px`;
  copy.style.margin = '0';
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', String(width));
  svg.setAttribute('height', String(height));
  svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  const foreign = document.createElementNS(svg.namespaceURI, 'foreignObject');
  foreign.setAttribute('width', '100%');
  foreign.setAttribute('height', '100%');
  foreign.appendChild(copy);
  svg.appendChild(foreign);
  const url = URL.createObjectURL(
    new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' })
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = `${title.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') || 'chart'}.svg`;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
